module.exports = __webpack_public_path__ + "img/Logov2.455dc6d3.png";